import getAxiosAuthHeaders from '../../../functions/getAxiosAuthHeaders';
import api from '../../../apis/api';

const createJob = async (job) => {
  return api.post(
    'job',
    { ...job },
    {
      headers: await getAxiosAuthHeaders(),
    }
  );
};

export default createJob;
